import { queryGameInfoApi } from "@@/alova";

/**
 * @description 游戏是否安装
 *
 */
export async function isGameInstall(gameId: string): Promise<boolean> {
  const gameInfo = await queryGameInfoApi({
    gameId,
    packageName: (await bpV2())?.selfPackageName
  });

  return (
    (
      await jsb?.execAsyncV2(
        "isGameInstall",
        gameInfo.packageName,
        gameInfo.installEnvStatus,
        gameInfo.id
      )
    )?.data ?? false
  );
}
